var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeguridad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #262626;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_609",
    "data-name": "Rectangle 609",
    className: "cls-1",
    width: 65,
    height: 65,
    transform: "translate(0 -0.041)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Seguridad",
    transform: "translate(0.047 0.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730",
    className: "cls-2",
    transform: "translate(-0.047 -0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2970",
    "data-name": "Path 2970",
    className: "cls-1",
    d: "M78.156,320.98H19.746a1.082,1.082,0,0,1-1.082-1.082V309.082A1.082,1.082,0,0,1,19.746,308H78.156a1.082,1.082,0,0,1,1.082,1.082V319.9a1.082,1.082,0,0,1-1.082,1.082m-57.329-2.163H77.075v-8.653H20.828Z",
    transform: "translate(-16.473 -272.275)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2971",
    "data-name": "Path 2971",
    className: "cls-1",
    d: "M78.153,112.123H19.742a1.082,1.082,0,0,1-.888-1.7l6.671-9.577a10.185,10.185,0,0,0,1.533-3.378q.009-.038.021-.075l3.554-10.9A3.325,3.325,0,0,1,33.851,84H64.043a3.325,3.325,0,0,1,3.219,2.491l3.553,10.9c.008.024.015.049.021.074a10.19,10.19,0,0,0,1.533,3.378l6.671,9.577a1.082,1.082,0,0,1-.888,1.7m-56.339-2.163H76.081l-5.487-7.877a12.339,12.339,0,0,1-1.848-4.054l-3.553-10.9c-.008-.025-.016-.051-.022-.076a1.164,1.164,0,0,0-1.131-.887H33.853a1.164,1.164,0,0,0-1.129.887c-.006.026-.014.051-.022.076l-3.553,10.9a12.34,12.34,0,0,1-1.848,4.054Z",
    transform: "translate(-16.47 -74.234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2972",
    "data-name": "Path 2972",
    className: "cls-1",
    d: "M62.738,407.822H2.164A2.25,2.25,0,0,1,0,405.659V403.5a2.165,2.165,0,0,1,2.163-2.163H62.738A2.25,2.25,0,0,1,64.9,403.5v2.163a2.166,2.166,0,0,1-2.163,2.163M2.164,405.659h0Zm.042,0H62.738v-2.114a.231.231,0,0,0-.042-.049H2.163v2.114a.223.223,0,0,0,.042.049",
    transform: "translate(0.027 -354.79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2973",
    "data-name": "Path 2973",
    className: "cls-1",
    d: "M35.147,176.885c-4.183,0-6.707-2.486-6.753-6.649,0,0,0-.008,0-.012v-.018A2.208,2.208,0,0,1,30.6,168H37a1.082,1.082,0,0,1,0,2.163H30.6a.041.041,0,0,0-.04.041v.008c.033,2.992,1.577,4.509,4.59,4.509a1.082,1.082,0,0,1,0,2.164",
    transform: "translate(-25.075 -148.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2974",
    "data-name": "Path 2974",
    className: "cls-1",
    d: "M450.933,176.885a1.082,1.082,0,1,1,0-2.163c3.013,0,4.557-1.517,4.589-4.509,0,0,0-.011,0-.012a.041.041,0,0,0-.042-.037h-6.4a1.082,1.082,0,1,1,0-2.163h6.4a2.208,2.208,0,0,1,2.2,2.207v.037c-.046,4.155-2.57,6.641-6.753,6.641",
    transform: "translate(-396.048 -148.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2975",
    "data-name": "Path 2975",
    className: "cls-1",
    d: "M78.413,225.616a1.082,1.082,0,0,1-.106-2.158c.113-.011,11.386-1.126,22.514-1.126s22.4,1.114,22.513,1.126a1.082,1.082,0,1,1-.215,2.153c-.111-.011-11.281-1.115-22.3-1.115s-22.187,1.1-22.3,1.115q-.055.005-.109.005",
    transform: "translate(-68.342 -196.535)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2976",
    "data-name": "Path 2976",
    className: "cls-1",
    d: "M221.556,53.156H206.413a1.082,1.082,0,0,1-1.082-1.082V47.748a1.082,1.082,0,0,1,1.082-1.082h15.144a1.082,1.082,0,0,1,1.082,1.082v4.327a1.082,1.082,0,0,1-1.082,1.082m-14.062-2.163h12.98V48.829h-12.98Z",
    transform: "translate(-181.506 -41.228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2977",
    "data-name": "Path 2977",
    className: "cls-1",
    d: "M171.369,7.571H142.163A2.25,2.25,0,0,1,140,5.407V2.162A2.163,2.163,0,0,1,142.163,0h29.206a2.25,2.25,0,0,1,2.163,2.163V5.407a2.166,2.166,0,0,1-2.163,2.163M142.163,5.407h0Zm.042,0h29.163v-3.2a.23.23,0,0,0-.042-.049H142.162v3.2a.228.228,0,0,0,.042.05",
    transform: "translate(-123.746 0.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2978",
    "data-name": "Path 2978",
    className: "cls-1",
    d: "M31.645,353.985h-11.9a1.082,1.082,0,0,1-1.082-1.082v-6.491a1.082,1.082,0,0,1,1.082-1.082h9.735a3.249,3.249,0,0,1,3.245,3.245V352.9a1.082,1.082,0,0,1-1.082,1.082m-10.817-2.164h9.735v-3.245a1.083,1.083,0,0,0-1.082-1.082H20.828Z",
    transform: "translate(-16.474 -305.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2979",
    "data-name": "Path 2979",
    className: "cls-1",
    d: "M66.413,353.985a1.082,1.082,0,0,1-1.082-1.082v-6.49a1.082,1.082,0,1,1,2.164,0v6.49a1.082,1.082,0,0,1-1.082,1.082",
    transform: "translate(-57.731 -305.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2980",
    "data-name": "Path 2980",
    className: "cls-1",
    d: "M432.98,353.988h-11.9A1.082,1.082,0,0,1,420,352.906v-4.327a3.249,3.249,0,0,1,3.244-3.245h9.735a1.082,1.082,0,0,1,1.082,1.082v6.49a1.082,1.082,0,0,1-1.082,1.082m-10.817-2.164H431.9V347.5h-8.653a1.083,1.083,0,0,0-1.081,1.082Z",
    transform: "translate(-371.296 -305.282)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2981",
    "data-name": "Path 2981",
    className: "cls-1",
    d: "M477.079,353.985A1.082,1.082,0,0,1,476,352.9v-6.49a1.082,1.082,0,1,1,2.164,0v6.49a1.082,1.082,0,0,1-1.082,1.082",
    transform: "translate(-420.803 -305.279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2982",
    "data-name": "Path 2982",
    className: "cls-1",
    d: "M200.046,356.828H178.413a1.082,1.082,0,0,1,0-2.164h21.634a1.082,1.082,0,1,1,0,2.164",
    transform: "translate(-156.751 -313.531)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2983",
    "data-name": "Path 2983",
    className: "cls-1",
    d: "M44.9,485.734H40.576a3.249,3.249,0,0,1-3.245-3.245v-5.408A1.082,1.082,0,0,1,38.413,476h8.653a1.082,1.082,0,0,1,1.082,1.082v5.408a3.249,3.249,0,0,1-3.245,3.245m-5.409-7.572v4.327a1.083,1.083,0,0,0,1.081,1.082H44.9a1.083,1.083,0,0,0,1.081-1.082v-4.327Z",
    transform: "translate(-32.976 -420.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2984",
    "data-name": "Path 2984",
    className: "cls-1",
    d: "M436.9,485.734h-4.327a3.249,3.249,0,0,1-3.245-3.245v-5.408A1.082,1.082,0,0,1,430.411,476h8.654a1.082,1.082,0,0,1,1.082,1.082v5.408a3.249,3.249,0,0,1-3.245,3.245m-5.409-7.572v4.327a1.083,1.083,0,0,0,1.081,1.082H436.9a1.083,1.083,0,0,0,1.081-1.082v-4.327Z",
    transform: "translate(-379.544 -420.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2985",
    "data-name": "Path 2985",
    className: "cls-1",
    d: "M337.079,6.49A1.082,1.082,0,0,1,336,5.409V1.082a1.082,1.082,0,0,1,2.164,0V5.409a1.082,1.082,0,0,1-1.082,1.082",
    transform: "translate(-297.029 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2986",
    "data-name": "Path 2986",
    className: "cls-1",
    d: "M75.871,445.154H21.991a1.082,1.082,0,0,1-.96-.584l-2.245-4.327a1.082,1.082,0,0,1,.96-1.58H79.238a1.082,1.082,0,0,1,.854,1.746l-3.367,4.327a1.082,1.082,0,0,1-.854.417m-53.223-2.163H75.342l1.684-2.164h-55.5Z",
    transform: "translate(-16.473 -387.796)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2987",
    "data-name": "Path 2987",
    className: "cls-1",
    d: "M206.413,7.572a1.082,1.082,0,0,1-1.082-1.082V1.082a1.082,1.082,0,0,1,2.163,0V6.49a1.082,1.082,0,0,1-1.082,1.082",
    transform: "translate(-181.506 0.03)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2988",
    "data-name": "Path 2988",
    className: "cls-1",
    d: "M281.479,123.5h-9.735a1.082,1.082,0,1,1,0-2.164h9.735a1.082,1.082,0,0,1,0,2.164",
    transform: "translate(-239.266 -107.24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguridad);
export default __webpack_public_path__ + "static/media/Seguridad.3182fb638d0cb25e49d3ccd6ca8eb761.svg";
export { ForwardRef as ReactComponent };